<div class="w-full h-full flex justify-center items-center bg-gris-4">
  <div class="bg-white rounded p-2 w-96 h-fit border border-gris-3 flex flex-col">
    <p class="w-full text-center bg-orange-1 rounded p-2 flex items-center">
      <span class="text-white text-4xl material-icons">
        error
      </span>
      <span class="text-white font-semibold">
        Cette école est réservée aux utilisateurs qui ont des enfants.
      </span>
    </p>

    <p class="my-4 text-center font-medium">
      Vous pouvez changer d'école ou changer de compte ci-dessous.
    </p>

    <div class="flex-1 flex flex-col items-center justify-center gap-2">
      <mk-action-button [enabled]="true" baseLabel="Changer de compte" class="h-12 w-full" baseIcon="person" (click)="this.switchAccount()"/>
      <mk-green-action-button [enabled]="true" baseLabel="Liste des restaurants" class="h-12 w-full" baseIcon="chevron_left" (click)="this.returnToIndex()"/>
    </div>
  </div>
</div>
